export default "__VITE_ASSET__DxymO1BF__"